import React from "react";
import { BabyIcon, ClipboardCheckIcon, FileTextIcon, UserPlusIcon, UsersIcon, SearchIcon, BoxIcon } from "lucide-react";
export type ReceptionTab = 'overview' | 'register' | 'queue' | 'reports' | 'reviewDue' | 'maternity' | 'search';
type ReceptionServiceCardsProps = {
  activeTab: ReceptionTab;
  onSelect: (tab: Exclude<ReceptionTab, 'overview'>) => void;
};
const cards: Array<{
  tab: Exclude<ReceptionTab, 'overview'>;
  name: string;
  caption: string;
  icon: BoxIcon;
  bg: string;
  ring: string;
}> = [{
  tab: 'register',
  name: 'Register New',
  caption: 'Add a new patient',
  icon: UserPlusIcon,
  bg: 'bg-[#221587]',
  ring: 'ring-[#221587]'
}, {
  tab: 'queue',
  name: 'Queue',
  caption: 'Patients waiting',
  icon: UsersIcon,
  bg: 'bg-[#8B2BE2]',
  ring: 'ring-[#8B2BE2]'
}, {
  tab: 'reports',
  name: 'Patient Reports',
  caption: 'Lab & radiology',
  icon: FileTextIcon,
  bg: 'bg-[#E0106F]',
  ring: 'ring-[#E0106F]'
}, {
  tab: 'reviewDue',
  name: 'Review Due',
  caption: 'Follow-up reviews',
  icon: ClipboardCheckIcon,
  bg: 'bg-[#D97706]',
  ring: 'ring-[#D97706]'
}, {
  tab: 'maternity',
  name: 'Maternity Registration',
  caption: 'Active maternity',
  icon: BabyIcon,
  bg: 'bg-[#0D9488]',
  ring: 'ring-[#0D9488]'
}, {
  tab: 'search',
  name: 'Patient Search',
  caption: 'View basic details',
  icon: SearchIcon,
  bg: 'bg-[#0369A1]',
  ring: 'ring-[#0369A1]'
}];
export function ReceptionServiceCards({
  activeTab,
  onSelect
}: ReceptionServiceCardsProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-10303" data-mp="in14pp10jt1m">
      {cards.map(({
      tab,
      name,
      caption,
      icon: Icon,
      bg,
      ring
    }) => {
      const isActive = activeTab === tab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} aria-pressed={isActive} className={`${bg} inline-flex max-w-full items-center gap-3 rounded-xl py-3 pl-3 pr-5 text-left text-white shadow-md shadow-gray-300/40 transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 ${ring} ${isActive ? 'ring-4 ring-offset-2 ring-offset-chrome-canvas' : ''}`} data-id="element-10304" data-mp="rlw8yvkhyt2a">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/20" data-id="element-10305" data-mp="15pvvwjso87gu">
              <Icon className="h-[18px] w-[18px] text-white" strokeWidth={2} aria-hidden="true" data-id="element-10306" data-mp="19njvi05b6of2" />
            </span>
            <span data-id="element-10307" data-mp="hygqgi5lla1d">
              <span className="block whitespace-nowrap text-sm font-semibold leading-tight" data-id="element-10308" data-mp="hyzwp1lvy9zk">
                {name}
              </span>
              <span className="block whitespace-nowrap text-xs text-white/85" data-id="element-10309" data-mp="m0bsxpz9ltgq">
                {caption}
              </span>
            </span>
          </button>;
    })}
    </div>;
}